import React, { useState, useEffect } from 'react'
import DrawerUI from '../../../widgets/layout/DrawerUI'
import FormSF from '../../../widgets/form/FormSF'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputSelectSF from '../../../widgets/form/InputSelectSF'
import InputCheckBoxUI from '../../../widgets/form/InputCheckBoxUI'
import InputDateUI from '../../../widgets/form/InputDateUI'
import './TermSheet.css'

const TermsUpdateFieldsUI = ({
  context, loan,
  loanName, onLoanNameChange, loanNameError, setLoanNameError,
  termSheetAmount, onTermSheetAmountChange, termSheetAmountError, setTermSheetAmountError,
  termSheetTenureMonths, onTermSheetTenureMonthsChange, termSheetTenureMonthsError, setTermSheetTenureMonthsError,
  interestTenureMonths, onInterestTenureMonthsChange, interestTenureMonthsError, setInterestTenureMonthsError, showInterestTenureMonths,
  termSheetInterestRate, onTermSheetInterestRateChange, termSheetInterestRateError, setTermSheetInterestRateError,
  termSheetApr, onTermSheetAprChange, termSheetAprError, setTermSheetAprError,
  processingFeePercent, onProcessingFeePercentChange, processingFeePercentError, setProcessingFeePercentError, processingFee,
  promoterFundF3, onPromoterFundF3Change, promoterFundF3Error, setPromoterFundF3Error,
  totalProjectCost, onTotalProjectCostChange, totalProjectCostError, setTotalProjectCostError,
  dsraPercent, onDsraPercentChange, dsraPercentError, setDsraPercentError, dsra,
  dsraMonths, onDsraMonthsChange, dsraMonthsError, setDsraMonthsError,
  dsraInterest, onDsraInterestChange,
  additionalDsraPercent, onAdditionalDsraPercentChange, additionalDsraPercentError, setAdditionalDsraPercentError,
  additionalDsraMonths, onAdditionalDsraMonthsChange, additionalDsraMonthsError, setAdditionalDsraMonthsError,
  additionalDsraDueDate, onAdditionalDsraDueDateChange,
  onLoanTenureMonthsChange, loanTenureMonths, loanTenureMonthsError, setLoanTenureMonthsError,
  loanType, onLoanTypeChange, loanTypeError, setLoanTypeError, loanTypeList,
  loanSubType, onLoanSubTypeChange, loanSubTypeError, setLoanSubTypeError, loanSubTypeList,
  numberOfRevolves, onNumberOfRevolvesChange, numberOfRevolvesError, setNumberOfRevolvesError,
  dsraReleaseAmount, onDsraReleaseAmountChange, dsraReleaseAmountError, setDsraReleaseAmountError,
  followUpLoan, onFollowUpLoanChange, moratorium, construction, onToggleMoratorium, onToggleConstruction,
  moratoriumPeriod, onMoratoriumPeriodChange, moratoriumPeriodError, setMoratoriumPeriodError,
  moratoriumInterestRate, onMoratoriumInterestRateChange, moratoriumInterestRateError, setMoratoriumInterestRateError,
  postMoratoriumInterestRate, onPostMoratoriumInterestRateChange, postMoratoriumInterestRateError, setPostMoratoriumInterestRateError,
  constructionPeriod, onConstructionPeriodChange, constructionPeriodError, setConstructionPeriodError,
  constructionInterestRate, onConstructionInterestRateChange, constructionInterestRateError, setConstructionInterestRateError,
  postConstructionInterestRate, onPostConstructionInterestRateChange, postConstructionInterestRateError, setPostConstructionInterestRateError,
}) => {
  const [showLoanTenure, setShowLoanTenure] = useState(false)
  useEffect(() => {
    setShowLoanTenure(!!loanTenureMonths)
  }, [loanTenureMonths])

  const onShowLoanTenure = () => {
    setShowLoanTenure(prev => !prev)
  }

  const showPhase = (loanType === 'project' || loanType === 'int_then_prj') && loanSubType === 'ppa'

  return (
    <div className='su_ts_form'>
      <div className='su_ts_section'>
        <div className='su_ts_section_title'>Loan</div>
        <InputTextSF type='text' name='s_name' required={true} maxLength={20}
          label='Loan name'
          value={loanName} onChange={onLoanNameChange}
          error={loanNameError} setError={setLoanNameError}
          autoFocus={true}
        />
        <div className='su_ts_row'>
          <InputSelectSF type='select' name='loan_type' required={true}
            label='Loan type'
            value={loanType} optionList={loanTypeList}
            onChange={onLoanTypeChange} error={loanTypeError} setError={setLoanTypeError}
          />
          <InputSelectSF type='select' name='loanSubType' required={true} label='Loan sub type'
            value={loanSubType} optionList={loanSubTypeList}
            onChange={onLoanSubTypeChange} error={loanSubTypeError} setError={setLoanSubTypeError}
          />
        </div>
        {
          showPhase &&
          <div className='su_ts_row'>
            <InputCheckBoxUI label='Moratorium' name='moratorium'
              checked={moratorium} onChange={onToggleMoratorium} />
            <InputCheckBoxUI label='Construction' name='construction'
              checked={construction} onChange={onToggleConstruction} />
          </div>
        }
        {
          showPhase && moratorium &&
          <div className='su_ts_row su_ts_row_3'>
            <InputTextSF type='text' name='moratoriumPeriod' required={true}
              label='Moratorium period'
              value={moratoriumPeriod} onChange={onMoratoriumPeriodChange}
              error={moratoriumPeriodError} setError={setMoratoriumPeriodError}
            />
            <InputTextSF type='text' name='moratoriumInterestRate' required={true}
              label='Moratorium rate'
              value={moratoriumInterestRate} onChange={onMoratoriumInterestRateChange}
              error={moratoriumInterestRateError} setError={setMoratoriumInterestRateError}
            />
            <InputTextSF type='text' name='postMoratoriumInterestRate' required={true}
              label='Post-moratorium rate'
              value={postMoratoriumInterestRate} onChange={onPostMoratoriumInterestRateChange}
              error={postMoratoriumInterestRateError} setError={setPostMoratoriumInterestRateError}
            />
          </div>
        }
        {
          showPhase && construction &&
          <div className='su_ts_row su_ts_row_3'>
            <InputTextSF type='text' name='constructionPeriod' required={true}
              label='Construction period'
              value={constructionPeriod} onChange={onConstructionPeriodChange}
              error={constructionPeriodError} setError={setConstructionPeriodError}
            />
            <InputTextSF type='text' name='constructionInterestRate' required={true}
              label='Construction rate'
              value={constructionInterestRate} onChange={onConstructionInterestRateChange}
              error={constructionInterestRateError} setError={setConstructionInterestRateError}
            />
            <InputTextSF type='text' name='postConstructionInterestRate' required={true}
              label='Post-construction rate'
              value={postConstructionInterestRate} onChange={onPostConstructionInterestRateChange}
              error={postConstructionInterestRateError} setError={setPostConstructionInterestRateError}
            />
          </div>
        }
      </div>

      <div className='su_ts_section'>
        <div className='su_ts_section_title'>Terms</div>
        <div className='su_ts_row'>
          <InputTextSF type='text' name='s_amt' required={true} maxLength={12}
            label='Loan amount (₹)' help={`Requested: ${loan.loanRequest.amountF2}`}
            value={termSheetAmount} onChange={onTermSheetAmountChange}
            error={termSheetAmountError} setError={setTermSheetAmountError}
          />
          <InputTextSF type='text' name='s_prfee' required={true} maxLength={6}
            label='Processing fee %'
            value={processingFeePercent} onChange={onProcessingFeePercentChange}
            error={processingFeePercentError} setError={setProcessingFeePercentError}
            help={processingFee > 0 && `Fee: ${processingFee}`}
          />
        </div>
        <div className='su_ts_row'>
          <InputTextSF type='text' name='s_tnr' required={true} maxLength={3}
            label='Amortized tenure (months)' help={`Requested: ${loan.loanRequest.tenureMonths} mo`}
            value={termSheetTenureMonths} onChange={onTermSheetTenureMonthsChange}
            error={termSheetTenureMonthsError} setError={setTermSheetTenureMonthsError}
          />
          {
            loanType === 'interest_only' &&
            <InputTextSF type='text' name='numberOfRevolves' required={true} maxLength={3}
              label='Total revolves'
              help={
                numberOfRevolves && termSheetTenureMonths && Number(termSheetTenureMonths) % Number(numberOfRevolves) === 0
                  ? `Each revolve: ${Number(termSheetTenureMonths) / Number(numberOfRevolves)} months`
                  : 'Tenure must be exactly divisible by total revolves'
              }
              value={numberOfRevolves} onChange={onNumberOfRevolvesChange}
              error={numberOfRevolvesError} setError={setNumberOfRevolvesError}
            />
          }
          <InputTextSF type='text' name='s_intr' required={true} maxLength={8}
            label='Interest rate p.a.'
            value={termSheetInterestRate} onChange={onTermSheetInterestRateChange}
            error={termSheetInterestRateError} setError={setTermSheetInterestRateError}
          />
        </div>
        <div className='su_ts_row'>
          <InputTextSF type='text' name='s_apr' maxLength={6}
            label='APR'
            value={termSheetApr} onChange={onTermSheetAprChange}
            error={termSheetAprError} setError={setTermSheetAprError}
          />
          {
            showInterestTenureMonths
              ? <InputTextSF type='text' name='s_tnr' required={true} maxLength={3}
                label='Interest-only tenure (months)'
                value={interestTenureMonths} onChange={onInterestTenureMonthsChange}
                error={interestTenureMonthsError} setError={setInterestTenureMonthsError}
              />
              : <div />
          }
        </div>
        {(loanType === 'project' || loanType === 'int_then_prj') && (
          <>
            <InputCheckBoxUI
              label='Loan tenure shorter than amortized tenure'
              onChange={onShowLoanTenure}
              checked={showLoanTenure}
              name='showLoanTenure'
            />
            {showLoanTenure && (
              <InputTextSF
                type='text'
                name='s_tnr'
                maxLength={3}
                label='Loan tenure (months)'
                value={loanTenureMonths || ''}
                onChange={onLoanTenureMonthsChange}
                error={loanTenureMonthsError}
                setError={setLoanTenureMonthsError}
              />
            )}
          </>
        )}
      </div>

      <div className='su_ts_section'>
        <div className='su_ts_section_title'>DSRA</div>
        <div className='su_ts_row'>
          <InputTextSF type='text' name='s_dsra' required={!dsraMonths} maxLength={6}
            label='DSRA %'
            value={dsraPercent} onChange={onDsraPercentChange}
            error={dsraPercentError} setError={setDsraPercentError}
            disabled={!!dsraMonths}
            help={dsra > 0 && `DSRA: ${dsra}`}
          />
          <InputTextSF type='text' name='s_dsra' required={!dsraPercent} maxLength={6}
            label='DSRA months'
            value={dsraMonths} onChange={onDsraMonthsChange}
            error={dsraMonthsError} setError={setDsraMonthsError}
            disabled={!!dsraPercent}
            help='Either % or months required'
          />
        </div>
        <InputCheckBoxUI label='DSRA interest'
          onChange={onDsraInterestChange} checked={dsraInterest}
          name='dsraInterest'
        />
        <div className='su_ts_row'>
          <InputTextSF type='text' name='additional_dsra_percent' maxLength={6}
            label='Additional DSRA %'
            value={additionalDsraPercent} onChange={onAdditionalDsraPercentChange}
            error={additionalDsraPercentError} setError={setAdditionalDsraPercentError}
            disabled={!!additionalDsraMonths}
            help='Clear both to release'
          />
          <InputTextSF type='text' name='additional_dsra_months' maxLength={6}
            label='Additional DSRA months'
            value={additionalDsraMonths} onChange={onAdditionalDsraMonthsChange}
            error={additionalDsraMonthsError} setError={setAdditionalDsraMonthsError}
            disabled={!!additionalDsraPercent}
            help='Months × EMI post moratorium'
          />
        </div>
        <InputDateUI context={context} name='additionalDsraDueDate'
          label='Additional DSRA due date'
          selectedDateISO={additionalDsraDueDate}
          onChange={onAdditionalDsraDueDateChange}
          help='After this date, ESCC surplus is classified as DSRA'
        />
        <InputTextSF type='text' name='dsra_release_amount' maxLength={12}
          label='DSRA release (₹)'
          value={dsraReleaseAmount} onChange={onDsraReleaseAmountChange}
          error={dsraReleaseAmountError} setError={setDsraReleaseAmountError}
          help='Amount of DSRA to release'
        />
      </div>

      <div className='su_ts_section'>
        <div className='su_ts_section_title'>Capital</div>
        <div className='su_ts_row'>
          <InputTextSF type='text' name='promo_fund' required={true} maxLength={10}
            label='Promoter contribution (₹)'
            help='Project cost − loan + fee + DSRA + deposit'
            value={promoterFundF3} onChange={onPromoterFundF3Change}
            error={promoterFundF3Error} setError={setPromoterFundF3Error}
          />
          <InputTextSF type='text' name='total_project_cost' required={false} maxLength={15}
            label='Total project cost (₹)'
            value={totalProjectCost} onChange={onTotalProjectCostChange}
            error={totalProjectCostError} setError={setTotalProjectCostError}
          />
        </div>
        {
          loan.appFlavor !== 'small_loan' &&
          <InputCheckBoxUI label='Followup loan'
            onChange={onFollowUpLoanChange} checked={followUpLoan}
            name='followUpLoan' help='Signs loan agreement and supplementary agreement'
          />
        }
      </div>
    </div>
  )
}

const TermsUpdateUI = ({ context, loan,
  isOpen, onCancelClick,
  onSubmit, submitted, successMsg, errorList, errorCode, setErrorList,
  ...fieldProps
}) =>
  <DrawerUI
    isOpen={isOpen}
    title='Edit terms'
    onClose={onCancelClick}
    className='su_ts_drawer'
    width='820px'
  >
    <FormSF context={context} buttonLabel='Update'
      cancelLabel='Cancel'
      onCancel={onCancelClick}
      onSubmit={onSubmit} busy={submitted}
      successMsg={successMsg} errorList={errorList} errorCode={errorCode} setErrorList={setErrorList}
    >
      <TermsUpdateFieldsUI context={context} loan={loan} {...fieldProps} />
    </FormSF>
  </DrawerUI>

export default TermsUpdateUI